var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-badge", _vm._b({}, "b-badge", _vm.variant, false), [
    _vm._v(" " + _vm._s(_vm._f("toEndOfDayFromNow")(_vm.expiredAt)) + " "),
    _vm.showDate
      ? _c("span", [
          _vm._v(" | " + _vm._s(_vm._f("dateFormat")(_vm.expiredAt)) + " ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }